import '../../assets/actions.css';
import { jsx as c } from "react/jsx-runtime";
import i from "clsx";
import { forwardRef as a } from "react";
const n = "_actions_14wch_1", m = {
  actions: n
}, e = a((o, s) => {
  const { className: t, ...r } = o;
  return /* @__PURE__ */ c("div", { ...r, ref: s, className: i(m.actions, t) });
});
e.displayName = "Combobox.Trigger.Actions";
export {
  e as Actions
};
